import { WeekmenuState } from "@app/types/root-state/weekmenu"
import { WeekMenuActionTypes, WeekMenuActions } from "../actions/weekmenuActionCreators"

// import { FavoriteRecipesData } from "../../types"

const initialState: WeekmenuState = {
    loading: false,
    data: [],
    error: undefined,
}

const weekmenuReducer = (state = initialState, action: WeekMenuActions): WeekmenuState => {
    switch (action.type) {
        // Get all
        case WeekMenuActionTypes.GetWeekMenuLoading:
            return { ...state, loading: true }
        case WeekMenuActionTypes.GetWeekMenuLoaded:
            return { ...state, loading: false }
        case WeekMenuActionTypes.GetWeekMenuSuccess:
            return { ...state, data: action.payload, error: undefined }
        case WeekMenuActionTypes.GetWeekMenuError:
            return { ...state, error: action.payload }

        // // get
        // case WeekMenuActionTypes.GetWeekMenuLoading:
        //     return { ...state, remove: { ...state.remove, loading: action.payload } }
        // case WeekMenuActionTypes.GetWeekMenuLoaded:
        //     return { ...state, remove: { ...state.remove, loading: false } }
        // case WeekMenuActionTypes.GetWeekMenuSuccess:
        //     return {
        //         ...state,
        //         data: setRemoved(state.data, action.payload, true),
        //         remove: { ...state.remove, error: null },
        //     }
        // case WeekMenuActionTypes.GetWeekMenuError:
        //     return { ...state, remove: { ...state.remove, error: action.payload } }

        default:
            return state
    }
}

export default weekmenuReducer
